export const searchBar = () => {
  const openSearchBar = document.getElementById("openSearchBar");
  const navbarSearchbar = document.getElementById("navbarSearchbar");

  if (openSearchBar && navbarSearchbar) {
    const toggleSearchbar = () => {
      const isOpening = !navbarSearchbar.classList.contains("opened");

      if (isOpening && window.closeAllDropdowns) {
        window.closeAllDropdowns();
      }

      navbarSearchbar.classList.toggle("opened");
    };

    openSearchBar.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleSearchbar();
    });

    document.addEventListener("click", (event) => {
      if (
        navbarSearchbar.classList.contains("opened") &&
        !navbarSearchbar.contains(event.target) &&
        event.target !== openSearchBar
      ) {
        toggleSearchbar();
      }
    });

    navbarSearchbar.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  }
};
